import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { INTL_TEL_INPUT } from '@constants/app.constants';
import { UserIpDataModel } from '@models/user-ip-data.model';
import { Observable, shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  readonly ipLookupUrl = INTL_TEL_INPUT.IPLOOKUP_URL;
  private httpClient = inject(HttpClient);

  // In-memory cache for the geo lookup — the client's IP doesn't change
  // within a session, so every phone-input instance (and any other caller)
  // can share a single backend round-trip. Cleared on error so transient
  // failures don't poison the cache.
  private userCountry$: Observable<UserIpDataModel> | null = null;

  sortBy(collection: Array<any>, property: string): Array<any> {
    collection.sort((a: any, b: any) => {
      if ((a[property] ? a[property].toLowerCase() : undefined) < (b[property] ? b[property].toLowerCase() : undefined)) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      } else {
        return 0;
      }
    });
    return collection;
  }

  getUserCountry(): Observable<UserIpDataModel> {
    if (!this.userCountry$) {
      this.userCountry$ = this.httpClient.get<UserIpDataModel>(this.ipLookupUrl).pipe(
        tap({ error: () => { this.userCountry$ = null; } }),
        shareReplay(1)
      );
    }
    return this.userCountry$;
  }
}
